/**
 * Effects actions
 */

import {
  RUN_EFFECT_V3,
  RUN_EFFECT_V3_SUCCESS,
  UNLOAD_EFFECT_V3,
} from "../constants";

/**
 * @desc run effect
 *
 * @param {string} source - Name of effect. The name 'source' is historical
 * @param {string} pageType - Type of page to load effect from (i.e. one of form, view, formBuilder etc).
 * @param {objectId} pageId - The id of page to fetch from.
 * @param {objectId} componentId - The id of componet to fetch.
 * @param {string} effectId - The key for props.effects[]. Identifies the effect.
 * @param {object} [props] - props for the effect. Only used when fetching test-effects from builders.
 * @param {object} context - The context of this effect
 * @param {string} applicationRef - applicationRef of effect
 *
 * @return {json} - redux
 *
 */
export const runEffect3 = ({
  source,
  pageType,
  pageId,
  props,
  componentId,
  effectId,
  context,
  applicationRef,
  clientStatus,
}) => {
  return {
    type: RUN_EFFECT_V3,
    source,
    pageId,
    props,
    componentId,
    context,
    pageType,
    effectId,
    applicationRef,
    clientStatus,
  };
};

/**
 * @desc run a effect SUCCESS.
 *
 * @param data - loaded data
 * @param _id - _id of component
 * @return {json} - redux
 *
 */
export const runEffect3Success = ({ data, effectId }) => {
  return {
    type: RUN_EFFECT_V3_SUCCESS,
    data,
    effectId,
  };
};

/**
 * @desc Unloads a effect from reducer
 *
 * @param data - loaded data
 * @param _id - _id of component
 * @return {json} - redux
 *
 */
export const unloadEffect3 = ({ effectId }) => {
  return {
    type: UNLOAD_EFFECT_V3,
    effectId,
  };
};
